export default "__VITE_ASSET__BfOkg3Vb__"